<template>
  <div class="row">

    <div 
      class="mark-card col-12 col-md-6 col-xl-4"
      v-for="interview in interviews" 
      :key="interview.id"
    >
      <div
        class="markCard interview-card-custom1"
        @click="goToDetail(interview)"
      >
        <!-- Статус -->
        <span
          class="interview-status"
          :class="statusStyle(interview.status)"
        >
          {{ statusLabel(interview.status) }}
        </span>

        <!-- Заголовок -->
        <h3>{{ interview.title }}</h3>

        <!-- Кандидат -->
        <div class="container-user-interview">
          <div class="h-v-center">
            <div class="container-img">
              <div
                v-if="hasAvatar(interview.interviewee)"
                class="custom-bg-img"
                :style="avatarStyle(interview.interviewee.avatar)"
              />
              <img v-else src="@/assets/img/no-foto.png" />
            </div>
          </div>

          <div class="right-block-interview">
            <h4>
              {{ interview.interviewee.name }}
              {{ interview.interviewee.lastName }}
            </h4>
            <p>Кандидат</p>
          </div>
        </div>

        <!-- Навыки -->
        <div class="info-interview">
          <p class="text-dop">Навыки кандидата:</p>
          <div class="interview-person skills-block">
            <template v-if="skillsMap[interview.id] && !skillsMap[interview.id].loading">
              <template v-if="skillsMap[interview.id].hard.length || skillsMap[interview.id].soft.length">
                <avatars-group
                  v-if="skillsMap[interview.id].hard.length"
                  :items="skillsMap[interview.id].hard"
                  class="avatarGroup"
                  type="hard"
                  :limit="5"
                />
                <avatars-group
                  v-if="skillsMap[interview.id].soft.length"
                  :items="skillsMap[interview.id].soft"
                  class="avatarGroup"
                  type="soft"
                  :limit="5"
                />
              </template>

              <div v-else class="table-small-text">Нет данных</div>
            </template>
          </div>
        </div>

        <!-- Время -->
        <div class="info-interview">
          <p class="text-dop">Тип интервью:</p>
          <div class="interview-person">
            <span>{{ getType(interview) }}</span>
          </div>
        </div>

        <!-- Время -->
        <div class="info-interview">
          <p class="text-dop">Время начала:</p>
          <div class="interview-person">
            <span>{{ formatDate(interview.dateTime) }}</span>
          </div>
        </div>

        <!-- Роль -->
        <div class="info-interview">
          <p class="text-dop">Моя роль в интервью:</p>
          <div class="interview-person">
            <span>{{ type }}</span>
          </div>
        </div>

        <!-- Участники -->
        <div class="info-interview">
          <p class="text-dop">Участники интервью:</p>

          <div class="participants">
            <!-- Владелец -->
            <div class="container-img mr-1" :title="interview.owner.name + ' ' + interview.owner.lastName">
              <div
                v-if="hasAvatar(interview.owner)"
                class="custom-bg-img"
                :style="avatarStyle(interview.owner.avatar)"
              />
              <img v-else src="@/assets/img/no-foto.png" />
            </div>

            <!-- Участники -->
            <div
              v-for="participant in interview.participants"
              :key="participant.id"
              class="container-img mr-1"
              :title="participant.name + ' ' + participant.lastName"
            >
              <div
                v-if="hasAvatar(participant)"
                class="custom-bg-img"
                :style="avatarStyle(participant.avatar)"
              />
              <img v-else src="@/assets/img/no-foto.png" />
            </div>
          </div>
        </div>
      </div>
      
      <!-- Кнопки админа -->
      <v-col
        v-if="isAdmin"
        class="edit-mark-card interview-btn"
      >
        <v-btn
          class="edit-field-button"
          title="Редактировать"
          variant="text"
          text
          @click.stop="openEntityEditor(interview)"
        >
          <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>

        <v-btn
          class="delete-field-button"
          title="Удалить"
          variant="text"
          text
          @click.stop="delEntity(interview)"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>
      </v-col>

    </div>

  </div>
</template>

<script>
import GlobalRequest from "@/plugins/globalRequest";
import globalMethods from "@/plugins/globalMethods"
import AvatarsGroup from "@/components/Cards/AvatarsGroup";

export default {
  name: "InterviewCard",

  components: {
    AvatarsGroup
  },

  props: {
    interviews: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: ""
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      skillsMap: {}
    };
  },

  mounted() {
    this.ensureSkillsLoaded();
  },

  // watch: {
  //   interviews: {
  //     deep: false,
  //     handler() {
  //       this.ensureSkillsLoaded();
  //     }
  //   }
  // },

  methods: {

    goToDetail(item) {
      this.$emit("goTo", item);
    },

    openEntityEditor(item) {
      this.$emit("editInterview", item);
    },

    delEntity(item) {
      this.$emit("delInterview", item);
    },

    hasAvatar(user) {
      return user && user.avatar;
    },

    avatarStyle(path) {
      return {
        backgroundImage: 'url("' + path + '")',
        width: "100%",
        height: "100%"
      };
    },

    formatDate(value) {
      if (!value) return "";

      const [date, time] = value.split('T');
      const [year, month, day] = date.split('-');

      return `${day}.${month}.${year} ${time}`;
    },

    statusStyle(status) {
      const map = globalMethods.interviewStatusClass(); 
      return map[status] || "";
    },

    statusLabel(status) {
      const map = globalMethods.interviewStatusLabels();
      return map[status] || "";
    },

    async loadSkillsForInterview(interview) {
      if (!interview || !interview.id) return;

      if (this.skillsMap[interview.id]) return;

      this.$set(this.skillsMap, interview.id, { hard: [], soft: [], loading: true });

      var userId = interview && interview.interviewee ? interview.interviewee.id : null;
      if (!userId) {
        this.$set(this.skillsMap, interview.id, { hard: [], soft: [], loading: false });
        return;
      }

      try {
        var res = await GlobalRequest.request("/root/" + userId, "GET");
        var root = res && res.data ? res.data : res;

        var hardRaw = (root && root.hardSkills && Array.isArray(root.hardSkills.areas))
          ? root.hardSkills.areas
          : [];

        var softRaw = (root && root.softSkills && Array.isArray(root.softSkills.areas))
          ? root.softSkills.areas
          : [];

        var hard = this.normalizeAreasForAvatarsGroup(hardRaw);
        var soft = this.normalizeAreasForAvatarsGroup(softRaw);

        this.$set(this.skillsMap, interview.id, { hard: hard, soft: soft, loading: false });
      } catch (e) {
        console.warn("Не удалось получить навыки для", userId, e);
        this.$set(this.skillsMap, interview.id, { hard: [], soft: [], loading: false });
      }
    },

    ensureSkillsLoaded() {
      for (var i = 0; i < this.interviews.length; i++) {
        this.loadSkillsForInterview(this.interviews[i]);
      }
    },

    toNumber(val) {
      if (val === null || typeof val === "undefined") return null;
      var num = Number(val);
      return isNaN(num) ? null : num;
    },

    normalizeAreasForAvatarsGroup(list) {
      var arr = Array.isArray(list) ? list : [];

      return arr
      .map((n) => {
        var scoreNum = this.toNumber(n && n.score);

        if (scoreNum === null || scoreNum <= 0) return null;

        return {
          id: n.id,
          element: {
            title: n.title,
            viewerRights: n.viewerRights || null
          },
          score: {
            score: scoreNum
          }
        };
      })
      .filter(Boolean);
    },

    getType(interview) {
      if(interview && interview.type && interview.type.name) {
        return interview.type.name
      } else {
        return "Не определено"
      }
    }

  },
};
</script>

<style scoped>
.interview-btn {
  margin-top: -8px;
}

.participants {
  display: flex;
  align-items: center;
}
.skills-block {
  min-height: 28px;
}
</style>
